export const environment = {
    baseUrl: 'https://devbackend.pias.sg',
    apis: {
        login: '/v2/pias/login',
        loginMfa: '',
        logout: '/v2/pias/logout',
        dashboardInceptedApe: '/v22/pias/dashboard-ape',
        dashboardGrossRevenue: '/v22/pias/dashboard-grossrevenue',
        dashboardPiasConvention: '/v22/pias/dashboard-convention',
        dashboardMdrtStatus: '/v22/pias/dashboard-mdrt',
        dashboardBranchwiseadvisors: '/v2/pias/branchwiseagent',
        dashboardInceptedApeDirectorwiseManagers: '/v2/pias/directorwisemanager',
        dashboardInceptedApeManagerwiseAdvisors: '/v2/pias/managerwiseagent',
        getAgentsByPiasId: '/v2/pias/getagents',
        dashboardGrossRevenueDirectorwiseManagers: '/v2/pias/dashboard-grossrevenue/directorwisemanager',
        dashboardGrossRevenueManagerwiseAdvisors: '/v2/pias/dashboard-grossrevenue/managerwiseagent',
        getDownloadResourceCategory: '/v2/pias/resource/getcategory',
        getDownloadResourcelist: '/v2/pias/resource/getresourcecategory',
        userLogDocument: '/v2/pias/user-log-document',
        getUserList: '/v1/pias/user/userlist',
        createNewUser: '/v1/pias/user/createuser',
        registerUser: '/v2/pias/registeration',
        verifyEmailOtp: '/v2/pias/emailverify',
        resendEmailOtp: '/v2/pias/resentotp',
        changeUserPassword: '/v2/pias/updatepassword',
        verifyForgotPasswordOtp: '/v2/pias/forgotpassword',
        updateForgotPassword: '/v2/pias/confirmforgotpassword',
        constants: '/v2/pias/constants',
        verifyOtp: '/v2/pias/verifyotp',
        resendOtp: '/v2/pias/resendotp'
    },
    security: {
        enableOtpVerification: false
    }
};
